// Source: https://usehooks-ts.com/react-hook/use-event-callback.
import { useCallback, useRef } from 'react';
import useIsomorphicLayoutEffect from './use-isomorphic-layout-effect.js';
/**
 * Custom hook that creates a memoized event callback.
 */
function useEventCallback(fn) {
    const ref = useRef(() => {
        throw new Error('Cannot call an event handler while rendering.');
    });
    useIsomorphicLayoutEffect(() => {
        ref.current = fn;
    }, [fn]);
    return useCallback((...args) => ref.current?.(...args), [ref]);
}
export default useEventCallback;
